<template>
  <div class="graph-toolbar">
    <el-button-group>
      <el-button size="small" type="primary" icon="el-icon-plus" @click="$emit('add-node')">添加节点</el-button>
<el-button size="small" icon="el-icon-zoom-in" @click="$emit('zoom-in')">放大</el-button>
      <el-button size="small" icon="el-icon-zoom-out" @click="$emit('zoom-out')">缩小</el-button>
      <el-button size="small" icon="el-icon-rank" @click="$emit('zoom-fit')">适应</el-button>
      <el-button size="small" icon="el-icon-aim" @click="$emit('reset-view')">定位</el-button>
      <el-button size="small" icon="el-icon-download" @click="$emit('export-svg')">导出SVG</el-button>
    </el-button-group>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class GraphToolbar extends Vue {
  @Prop({ default: '/nodeDetailV2' }) readonly listViewRoute!: string
}
</script>

<style scoped lang="scss">
.graph-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: white;
  border-bottom: 1px solid #e5e7eb;
  border-radius: 8px 8px 0 0;

  .switch-view-link {
    text-decoration: none;
  }
}
</style>
